import { render, staticRenderFns } from "./RecoverConfirmCode.vue?vue&type=template&id=387a7031&scoped=true"
import script from "./RecoverConfirmCode.vue?vue&type=script&lang=js"
export * from "./RecoverConfirmCode.vue?vue&type=script&lang=js"
import style0 from "./RecoverConfirmCode.vue?vue&type=style&index=0&id=387a7031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a7031",
  null
  
)

export default component.exports